<div class="app-page" style="margin-left: 10px;color: white; ">
  <!-- <mat-progress-bar mode="indeterminate" *ngIf="this.isBusy()"></mat-progress-bar> -->
  <div style="display: flex; flex-direction: row; flex-wrap: wrap;">
    <div style="display: flex;flex-direction: row; margin-right: 30px;">
      <!-- <img src="../../assets/img/icons8-user-shield-48.png" style="height: 48px;"/><br/> -->
      <mat-icon style="font-size: 70px; height: 100px; width: 70px;">account_circle</mat-icon>
      <div>
        <span style="font-size: x-large; ">{{this._playerData?.FlowPlayer.FirstName }}
        {{_playerData?.FlowPlayer.LastName}}</span><br />
        <span style="font-size: small; ">
          {{this._playerData?.FlowPlayer.DateOfBirth | date: 'yyy-MM-dd'}}
        </span>
      </div>

    </div>
    <div style="font-size: small;">
      <span style=" font-size: medium;">General</span>
      <table>
        <tr>
          <td style="width: 70px;">Age:</td>
          <td>
            {{this._playerData?.PlayerAgeYear }} years {{this._playerData?.PlayerAgeMonth }} months
          </td>
          <td></td>
          <td style="width: 70px;">Height:</td>
          <td>{{this._playerData?.FlowPlayer.Height }} cm</td>
        </tr>
        <tr>
          <td>Position:</td>
          <td></td>
          <td></td>
          <td>Weight:</td>
          <td>{{this._playerData?.FlowPlayer.Weight }} kg</td>
        </tr>

        @if (this._playerData?.Module_Tags) {
          <tr>
            <td>Tags:</td>
            <td>
              <div style="display:flex; align-items: baseline;">
                @for (tag of this._playerData.tags; track tag) {
                  <div [ngClass]="tag.TagColor"
                    (click)="openShowTagDialog();" style="height: 20px;">
                    {{tag.TagText}}
                  </div>
                }
                <button mat-icon-button aria-label="Add" (click)="addTag()">
                  <mat-icon>add</mat-icon>
                </button>
                <button mat-icon-button aria-label="Edit" (click)="openShowTagDialog();">
                  <mat-icon>remove</mat-icon>
                </button>
              </div>
            </td>
            <td>
            </td>
          </tr>
        }

      </table>



    </div>
  </div>


  @if (this._playerData) {
    <div>
      <div class="mat-tab-body-wrapper"
        style=" display: flex; flex-wrap: wrap; align-content: flex-start; height: 60vh;">
        <div>
          <label>RANKING LISTS</label>
          @for (list of this._playerData.playerplayerlist; track list) {
            <app-player-ranking-list-entry [List]="list">
            </app-player-ranking-list-entry>
          }
          @if (this._playerData?.playerplayerlist.length==0) {
            <div STYLE="color: gray;;">
              NOT IN ANY LIST VISIBLE TO YOU
            </div>
          }
          <br />
        </div>
        @if (this._playerData.flowitem.length==0) {
          <div style="color: gray;">
            <br />
            NO REPORTS FOUND
          </div>
        }
        <div style="width: 100%;">
          @if (this.ProjectionTexts && this._playerData.flowitem.length>0) {
            <app-chart-player-projection
              [Reports]="this._playerData.flowitem" [Ticks]="this.ProjectionTexts"
            [Ticks2]="this.tickValues"></app-chart-player-projection>
          }
        </div>
        <div style=" display: flex; flex-wrap: wrap; align-content: flex-start; ">
          @for (item of this._playerData.flowitem; track item) {
            @if (item.FlowItemType=='SCREPORT') {
              <app-report-card-player [Report]="item"
              ></app-report-card-player>
            }
            @if (item.FlowItemType=='PLAYERNOTE') {
              <app-note-card-player [Note]="item"></app-note-card-player>
            }
          }
        </div>
      </div>
    </div>
  }